import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Parse from "parse";
import { API_URL, PARSE_APPLICATION_ID, PARSE_REST_API_KEY } from "../api";

export const getMe = createAsyncThunk(
  "user/getMe",
  async (_, { rejectWithValue }) => {
    try {
      const res = await Parse.User.me();
      if (res.error) {
        rejectWithValue(res.error);
      }
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// get user with specific id
export const getUser = createAsyncThunk(
  "user/getUser",
  async (payload, { rejectWithValue }) => {
    try {
      const url = API_URL + "/users/" + payload.userId;
      const options = {
        method: "GET",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
        },
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updateUserById = createAsyncThunk(
  "user/updateUserById",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/users/" + payload.userId;
      const user = getState().user.userMe;
      const preparedPayload = payload.avatar
        ? {
            username: payload.username,
            phone: payload.phone,
            avatar: payload.avatar,
          }
        : { username: payload.username, phone: payload.phone };
      const options = {
        method: "PUT",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },

        body: JSON.stringify(preparedPayload),
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  getMeLoading: "IDLE",
  getMeError: null,
  userMe: null,
  userMeId: null,
  getCurrentUserLoading: "IDLE",
  getCurrentUserError: null,
  currentUser: null,
  updateUserLoading: "IDLE",
  updateUserError: null,
  currentUserId: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMe.pending, (state, action) => {
      state.getMeLoading = "PENDING";
      state.getMeError = null;
    });
    builder.addCase(getMe.fulfilled, (state, action) => {
      state.getMeLoading = "SUCCESS";
      state.userMe = action.payload.attributes;
      state.userMeId = action.payload.id;
      state.currentUserId = action.payload.id;
      state.getMeError = null;
    });
    builder.addCase(getMe.rejected, (state, action) => {
      state.getMeLoading = "FAILED";
      state.getMeError = action.payload;
    });

    builder.addCase(getUser.pending, (state, action) => {
      state.getCurrentUserLoading = "PENDING";
      state.getCurrentUserError = null;
    });
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.getCurrentUserLoading = "SUCCESS";
      state.currentUser = action.payload;
      state.getCurrentUserError = null;
    });
    builder.addCase(getUser.rejected, (state, action) => {
      state.getCurrentUserLoading = "FAILED";
      state.getCurrentUserError = action.payload;
    });

    builder.addCase(updateUserById.pending, (state, action) => {
      state.updateUserLoading = "PENDING";
      state.updateUserError = null;
    });
    builder.addCase(updateUserById.fulfilled, (state, action) => {
      state.updateUserLoading = "SUCCESS";
      state.updateUserError = null;
    });
    builder.addCase(updateUserById.rejected, (state, action) => {
      state.updateUserLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.updateUserError = err;
    });
  },
});

// this is for dispatch
export const {} = userSlice.actions;

// this is for configureStore
export default userSlice.reducer;
